import { css } from '@emotion/react';
import mobileContentWidthCSS from '../../../../constants/mobileContentWidthCSS';

export const desktopCSS = css`
    display: flex;
    flex-direction: column;
`;

export const mobileCSS = css`
    display: flex;
    flex-direction: column;
    align-items: center;

    & > div {
        ${mobileContentWidthCSS};
    }

    & > button:first-of-type {
        margin: 2.333rem 0 2.667rem;
    }
`;

export const mobilePhoneNumberFieldCSS = css`
    display: flex;
    flex-direction: column;
`;

export const phoneNumberFieldCSS = css`
    position: relative;
    display: flex;
    gap: 1.667rem;
    width: 100%;

    & > div {
        label + div {
            width: 16.667rem;
        }
    }
`;

export const saveCancelActionsCSS = css`
    display: flex;
    align-self: end;
    align-items: center;
    gap: 1.667rem;
    margin-top: 3.333rem;

    > button {
        width: initial;
        min-width: 8.333rem;
    }
`;

export const legalNameVerifiedCSS = ({ textInputWidthXL }) => css`
    width: ${textInputWidthXL};
`;
